/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Grid } from "@mui/material";
import { FC, useEffect } from "react";
import { useParams } from "react-router";
import { RoleAPI } from "../../api";
import { useGlobalRoleContext } from "../../hooks/useGlobalRoleContext";
import { currentUserId } from "../../lib/auth";
import NotFound from "../app/NotFound";
import { ProcessExecutionScreen } from "./components/execution";
import { ProcessExecutionProvider } from "./hooks";
import useProcessExecution from "./hooks/useProcessExecution";

const ACCOUNT_PORTAL = "ACCOUNT_PORTAL";
const ORGANIZATION_PORTAL = "ORGANIZATION_PORTAL";

export type AccountTaskExecutionPageProps = {
  returnTo?: typeof ORGANIZATION_PORTAL | typeof ACCOUNT_PORTAL | undefined;
  showAttachments?: boolean;
};

const AccountTaskExecutionPage: FC<AccountTaskExecutionPageProps> = ({
  showAttachments = true,
}) => {
  const { processExecutionId } = useParams();
  const { setRoles } = useGlobalRoleContext();

  useEffect(() => {
    // get the unique roles for the account context
    const userId = currentUserId();
    RoleAPI.byAccountRole(userId).then((roles) => {
      setRoles(roles);
    });
  }, [setRoles]);

  if (!processExecutionId) {
    return <NotFound />;
  }

  return (
    <>
      <Grid
        container
        sx={{
          height: "100%",
          position: "relative",
          justifyContent: "center",
          alignContent: "flex-start",
          backgroundColor: "background.drawer",
          p: 2,
          flex: 1,
        }}
        spacing={2}
      >
        <Grid
          size={{ xs: 12, md: 8, lg: 6 }}
          offset={showAttachments ? 2 : 0}
          sx={{ maxHeight: 1, minHeight: "100%" }}
        >
          <ProcessExecutionProvider
            // eslint-disable-next-line react-hooks/rules-of-hooks
            value={useProcessExecution(processExecutionId)}
          >
            <ProcessExecutionScreen showAsPublicExecutor={true} />
          </ProcessExecutionProvider>
        </Grid>
        {/* {showAttachments && (
          <Grid xs={12} md={8} lg={2} sx={{ flex: 1 }}>
            {processExecution && (
              <ProcessExecutionSharedTaskExecutions
                processId={processExecution.process_id}
                processExecutionId={processExecution.id}
                attachmentReloadTrigger={1}
                variant="chip"
              />
            )}
          </Grid>
        )} */}
      </Grid>
    </>
  );
};

export default AccountTaskExecutionPage;
